import React from "react";
import PageContainer from "components/PageContainer";
import { AssetClass } from "types/AssetClass";

export default React.memo(() => {
  return (
    <PageContainer assetClass={AssetClass.PrivateDebt} title="private_debt" />
  );
});
